import { render, staticRenderFns } from "./loading-modal.vue?vue&type=template&id=f6f5c178"
import script from "./loading-modal.vue?vue&type=script&lang=js"
export * from "./loading-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports